'use client';

import { FC } from 'react';
import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import { usePathname } from 'next/navigation';
import { Button } from '@/components';

import { BorrowMoreAdvantages } from './BorrowMoreAdvantages/BorrowMoreAdvantages';
import { getPageName } from '@/utils';
import { routes } from '@/constants';
import NextButton from '@/components/Button/NextButton';
import { MODAL_NAMES } from '@/constants/modals';
import useModal from '@/hooks/useModal';
import styles from './textContent.module.scss';

const titleComponents = (variation: string): JSXMapSerializer => ({
  heading2: ({ children }) => (
    <h2 className={`${styles.title} ${styles[variation]}`}>{children}</h2>
  ),
});

type Props = {
  slice: Content.BorrowMoreSlice;
  isVisible: boolean;
};

export const TextContent: FC<Props> = ({ slice, isVisible }) => {
  const path = usePathname();
  const pageName = getPageName(path);
  const isPreQualifiedPage = pageName === routes.preQualified;
  const { openModal } = useModal();

  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <article className={`${styles.textContent} ${styles[slice.variation]}`}>
      <div className={`${styles.title_wrapper} ${isVisibleStyles}`}>
        <PrismicRichText
          field={slice.primary.title}
          components={titleComponents(slice.variation)}
        />
      </div>
      <p className={`${styles.subtitle} ${isVisibleStyles}`}>
        {slice.primary.subtitle}
      </p>
      {slice.variation === 'default' && (
        <BorrowMoreAdvantages
          advantages={slice.primary.advantages}
          isVisible={isVisible}
        />
      )}
      <div className={`${styles.button_wrapper} ${isVisibleStyles}`}>
        {isPreQualifiedPage ? (
          <NextButton
            type="button"
            styles={styles.button}
            text={slice.primary.button_text as string}
            onClick={() => openModal({ name: MODAL_NAMES.preQualified })}
          />
        ) : (
          <Button
            styles={styles.button}
            link={slice.primary.button_link}
            text={slice.primary.button_text}
          />
        )}
      </div>
    </article>
  );
};
